export default "__VITE_ASSET__CDrohy13__"